import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class UuidService {
  private static getRandomHexadecimal(length: number): string {
    return Array.from({ length }, () =>
      Math.floor(Math.random() * 16).toString(16),
    ).join("");
  }

  public static generateUUID(): string {
    return [
      this.getRandomHexadecimal(8),
      this.getRandomHexadecimal(4),
      `4${this.getRandomHexadecimal(3)}`,
      `${(Math.floor(Math.random() * 4) + 8).toString(
        16,
      )}${this.getRandomHexadecimal(3)}`,
      this.getRandomHexadecimal(12),
    ].join("-");
  }
}
